module.exports = __webpack_public_path__ + "img/logo.3451aa6c.png";